import React, { useEffect, useState } from "react";
import { Nav, Navbar, Stack } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { PersonCircleIcon, PersonIcon, logoIcon } from "../images/SVGs";

import {
  isHomevisit,
  BasicColor,
  ClinicColors,
  ContrastColor,
} from "../Utils/constants";

import InternetStatus from "../Utils/InternetStatus";
import CountdownTimer from "./TimeCountDown";

function Header() {
  const [showLoginModal, setshowLoginModal] = useState(false);
  const [expanded, setExpanded] = useState(true);

  useEffect(() => {
    setExpanded(!expanded);
  }, []);
  return (
    <Navbar
      dir="rtl"
      lang="ar"
      expand="lg"
      expanded={expanded}
      style={{
        backgroundColor: BasicColor,
      }}
      onClick={() => setExpanded(!expanded)}
    >
      <Navbar.Brand href={"/"}>
        <img
          src={process.env.PUBLIC_URL + "gold.jpg"}
          width={160}
          height={100}
          style={{
            marginLeft: "15px",

            borderRadius: "7px",
          }}
        ></img>
      </Navbar.Brand>
      <CountdownTimer />
      <div>
        <Stack direction="horizontal" gap={1}>
          <InternetStatus style={{ margin: "10px" }} />
        </Stack>
      </div>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav fill variant="tabs">
          <Nav.Item>
            <NavLink className="nav-link" to="/" style={{ color: "white" }}>
              الرئيسية
            </NavLink>
          </Nav.Item>
          <Nav.Item>
            <NavLink
              className="nav-link"
              to="/Calculator"
              style={{ color: "white" }}
            >
              الحاسبة
            </NavLink>
          </Nav.Item>
          <Nav.Item>
            <NavLink
              className="nav-link"
              to="/download"
              style={{ color: "white" }}
            >
              تحميل
            </NavLink>
          </Nav.Item>

          <Nav.Item>
            <NavLink
              className="nav-link"
              to="/privacy"
              style={{ color: "white" }}
            >
              الخصوصية
            </NavLink>
          </Nav.Item>

          <Nav.Item>
            <NavLink
              className="nav-link"
              to="/support"
              style={{ color: "white" }}
            >
              الدعم
            </NavLink>
          </Nav.Item>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default Header;
